import { CustomFormSchemaFieldsRecord } from "common/records/CustomFormSchemaFields";
import { IJobResultingConfigData } from "common/records/JobResultingConfig";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { Nullable } from "common/types";

export const RECEIVE_JOB_RESULTING_CONFIG = "@org/RECEIVE_JOB_RESULTING_CONFIG";
export const UPDATE_JOB_RESULTING_REQUIRED = "@org/UPDATE_JOB_RESULTING_REQUIRED";
export const JOB_RESULTING_FIELD_DRAG_END = "@org/JOB_RESULTING_FIELD_DRAG_END";
export const DELETE_JOB_RESULTING_FIELD = "@org/DELETE_JOB_RESULTING_FIELD";
export const UPDATE_JOB_RESULTING_FIELD_TYPE = "@org/UPDATE_JOB_RESULTING_FIELD_TYPE";
export const ADD_JOB_RESULTING_FIELD_OPTION = "@org/ADD_JOB_RESULTING_FIELD_OPTION";
export const REMOVE_JOB_RESULTING_FIELD_OPTION = "@org/REMOVE_JOB_RESULTING_FIELD_OPTION";
export const RESET_JOB_RESULTING_FIELD = "@org/RESET_JOB_RESULTING_FIELD";
export const UPDATE_ORG_JOB_RESULTING_CONFIG = "@org/UPDATE_ORG_JOB_RESULTING_CONFIG";

export const JobResultingActions = {
  receiveJobResultingConfig: (jobResultingConfig: IJobResultingConfigData) =>
    createAction(RECEIVE_JOB_RESULTING_CONFIG, { jobResultingConfig }),
  updateJobResultingRequired: (fieldName: string, optionIndex: number, required: boolean) =>
    createAction(UPDATE_JOB_RESULTING_REQUIRED, { fieldName, optionIndex, required }),
  jobResultingFieldDragEnd: (optionIndex: number, oldIndex: number, newIndex: number) =>
    createAction(JOB_RESULTING_FIELD_DRAG_END, { optionIndex, oldIndex, newIndex }),
  deleteJobResultingField: (optionIndex: Nullable<number>, fieldName: string, fieldIndex: number) =>
    createAction(DELETE_JOB_RESULTING_FIELD, { optionIndex, fieldName, fieldIndex }),
  updateJobResultingFieldType: (optionIndex: Nullable<number>, fieldIndex: number) =>
    createAction(UPDATE_JOB_RESULTING_FIELD_TYPE, { optionIndex, fieldIndex }),
  addJobResultingFieldOption: (optionIndex: Nullable<number>, fieldIndex: number, isMultiCheck = false) =>
    createAction(ADD_JOB_RESULTING_FIELD_OPTION, { optionIndex, fieldIndex, isMultiCheck }),
  removeJobResultingFieldOption: (
    optionIndex: Nullable<number>,
    fieldIndex: number,
    fieldOptionIndex: number,
    isMultiCheck = false,
  ) => createAction(REMOVE_JOB_RESULTING_FIELD_OPTION, { optionIndex, fieldIndex, fieldOptionIndex, isMultiCheck }),
  resetJobResultingField: (
    optionIndex: Nullable<number>,
    fieldIndex: number,
    lastEditedField: Nullable<CustomFormSchemaFieldsRecord>,
  ) => createAction(RESET_JOB_RESULTING_FIELD, { optionIndex, fieldIndex, lastEditedField }),
  updateOrgJobResultingConfig: (orgId: number) => createAction(UPDATE_ORG_JOB_RESULTING_CONFIG, { orgId }),
};

export type JobResultingActions = ActionsUnion<typeof JobResultingActions>;
